import { Koi } from '@ksyos/koi';

export const alcoholDaysPerWeekSchema = Koi.number().min(0).max(7).precision(2);
export const alcoholGlassesPerDagSchema = Koi.number().min(0).max(50).precision(2);
export const weightInKgSchema = Koi.number().min(0).max(400).precision(2);
export const lengthInCmSchema = Koi.number().min(0).max(250).precision(2);
export const smokingPacksADaySchema = Koi.number().min(0).precision(2);
export const smokingYearsSchema = Koi.number().min(0).precision(2);
